module.exports = __webpack_public_path__ + "static/media/clock.127c92b3.svg";